import styles from './MealsSummary.module.css'

const MealsSummary = () =>{
    return <section className={styles.summary}>
      
        <p>
            IT'S YOUR FOOD. OUR AIM IS SIMPLE...GIVE YOU GURANTEED QUALITY FRESH FOOD AND FOR YOU TO BE 100% SATISFIED.</p>
            
   
    </section>

}

export default MealsSummary